import { COMPANY_NON_BANK_TYPES } from '../utils/common'

export const formatCompanyInfoData = (data) => {
  let companyHeader = { ...data }
  if (
    Object.values(COMPANY_NON_BANK_TYPES).includes(companyHeader.companyType)
  ) {
    companyHeader = {
      ...companyHeader,
      companyType: 'NonBank',
      companyTypeOrigin: companyHeader.companyType,
    }
  }
  return companyHeader
}
